// src/app/store/auth/auth.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { clearAuth, setAccessToken } from './auth.actions';

export interface AuthTokens {
  idToken?: string;
  refreshToken?: string;
  accessToken: string;
  tokenType: string;
  expiresIn: string; // viene del backend (segundos, string)
  expiresAt?: number; // <- lo agregamos (epoch ms)
}

export interface AuthState {
  accessToken: AuthTokens | null;
}

export const initialAuthState: AuthState = { accessToken: null };
// modifica el storage dea acuerdo a la accion
export const authReducer = createReducer(
  initialAuthState,
  on(setAccessToken, (s, { accessToken }) => {
    const expiresSec = Number(accessToken.expiresIn ?? 0);
    const expiresAt = Date.now() + expiresSec * 1000;
    return {
      ...s,
      accessToken: { ...accessToken, expiresAt },
    };
  }),
  on(clearAuth, () => initialAuthState)
);
